<template lang="pug">
    #member-center-admin-user-comment
      .card  
        .level.is-flex-wrap-wrap
          .level-left.is-flex-wrap-wrap.max-witdh-100
            .level-item.ml-2
                p {{ challengeName }}
          .level-right.is-flex-grow-1
            .level-item.mr-2
                WtButton.post-button(
                        semibold
                        :isRouterLink="false"
                        :isText="true"
                        color="grey"
                        @click.native="deleteDiscussionPostAction(data.id)"
                        ) Remove
        WtTile.blockquote
          | "{{data.text}}"
        br
        WtTile.small
          | {{ data.poster }}
        WtTile.small.is-grey.mb-2
          | {{ formatDate(data.postedDate) }}
  </template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtMediaObject from "@@/WtMediaObject/WtMediaObject";

export default {
  name: "MemberCenterAdminUserComment",
  components: { WtTitle, WtTile, WtButton, WtMediaObject },

  props: {
    data: {
      type: Object,
      required: true
    },

    deleteDiscussionPostAction: {
      type: Function,
      default: () => {}
    },

    challengeId: {
      type: Number,
      default: null
    },

    challengeName: {
      type: String,
      default: ""
    },

    pageInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    formatDate(timestamp) {
      const date = new Date(parseInt(timestamp) * 1000);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      const formattedDay = day < 10 ? `0${day}` : `${day}`;
      const formattedMonth = month < 10 ? `0${month}` : `${month}`;

      return `${formattedDay}/${formattedMonth}/${year}`;
    }
  }
};
</script>

<style lang="sass" scoped>
#member-center-admin-user-comment
  .title
    font-weight: bold
    font-size: 24px
    color
  .small
    font-size: 16px
    margin-left: 2%
  .is-grey
    color: $grey
  .card
    background-color: $white
    margin: 2%
  .no-padding
    padding: 0px !important
  .dropdown-star-icon
    margin-left: -5px
  .media-content
    max-width: 100%
  .ellipsis
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  .ellipsis:hover
    text-overflow: clip
    white-space: normal
    word-break: break-all
    .flex-container
    display: flex
    justify-content: space-between
    align-items: center

  .horizontal-align
    display: inline-block

  .blockquote
    padding-left: 1rem
    font-size: 20px
    font-weight: bold
  .post-button
    +tablet
      margin-top: $size-7
</style>
